/**
 * @generated SignedSource<<d3733e02b308fd81f4be19b6c4a0205c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Segment = "business" | "personal" | "sparkdigitalshop";
export type useIdentityAccountsQuery$variables = {};
export type useIdentityAccountsQuery$data = {
  readonly me: {
    readonly accountList: ReadonlyArray<{
      readonly accountId: string;
      readonly segment: Segment;
    }>;
  };
};
export type useIdentityAccountsQuery = {
  variables: useIdentityAccountsQuery$variables;
  response: useIdentityAccountsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountList",
        "kind": "LinkedField",
        "name": "accountList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "segment",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useIdentityAccountsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIdentityAccountsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "131cd4bcdb6964aeb62a6de98a639892",
    "id": null,
    "metadata": {},
    "name": "useIdentityAccountsQuery",
    "operationKind": "query",
    "text": "query useIdentityAccountsQuery {\n  me {\n    accountList {\n      accountId\n      segment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "54a20e6929724789a001e5caaeca1efd";

export default node;
